import {Component, Input, OnInit} from '@angular/core';
import {ILayoutSettings, IPageContent} from '@app/feature/store-editor/components/layout/store-editor.interface';
import {CommonService} from '@app/feature/store-editor/services/common.service';

@Component({
  selector: 'app-sub-layout-setting',
  templateUrl: './sub-layout-setting.component.html',
  styleUrls: ['../styling/styling.component.css']
})
export class SubLayoutSettingComponent implements OnInit {

  @Input() item: IPageContent;
  @Input() layoutSetting: ILayoutSettings;

  constructor(public cs: CommonService) {
  }

  ngOnInit() {
    this.item.data = this.cs.setDefaultSetting(this.item.data);
  }

  selectFileToBg(el: any) {
    const input = el.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(input);
    reader.onload = () => {
      this.item.data.bgImage = reader.result.toString();
      this.cs.uploadFile(input.name, reader.result.toString()).then(res => this.item.data.bgImage = res);
    };
  }


  imageSelector(image: string) {
    if (image) {
      return image;
    } else {
      return '/assets/img/imagePlaceholder.png';
    }
  }
}
